import { moduleForPath } from '../modules/registry.js';
// Explicit page adapters only. This store contains selections, never fetched business records.
let snapshot = null;
let revision = 0;
const listeners = new Set();
export const subscribePageContext = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export const getPageContext = () => snapshot;
export function publishPageContext(context, path = window.location.pathname) {
  snapshot = { ...context, context_revision: ++revision, path };
  listeners.forEach(fn => fn());
}
export function clearPageContext(path) {
  if (!path || snapshot?.path === path) { snapshot = null; listeners.forEach(fn => fn()); }
}
export function publishDemoContext(selection, state = {}) {
  if (!['overview', 'paid-media', 'crm'].includes(selection.page)) return;
  publishPageContext({
    version: 1, workspace_id: null, module_id: 'dashboard-demo',
    page_id: selection.page, dataset: selection.dataset || null,
    applied_filters: selection.filters || {}, date_range: { from: selection.from, to: selection.to },
    selected_kpis: state.selected_kpis || [],
    selected_dimensions: state.selected_dimensions || [],
    granularity: state.granularity || 'day',
    visuals: [],
  });
}
export function requestOrbitAI(question = '') {
  window.dispatchEvent(new CustomEvent('orbit-ai-open', { detail: { question } }));
}
export function boundaryFor(path, workspace) {
  if (path.startsWith('/dashboard-demo/')) return { kind: 'demo', key: 'dashboard-demo:demo', moduleId: 'dashboard-demo', label: 'Demo' };
  if (workspace.moduleId) return {
    kind: 'client', moduleId: workspace.moduleId, clientId: workspace.clientId, key: workspace.moduleId + ':client:' + (workspace.loading ? 'loading' : workspace.clientId || 'none'),
    label: workspace.loading ? 'Loading workspace' : workspace.client?.name || 'Choose a workspace',
  };
  const module = moduleForPath(path);
  return { kind: 'internal', moduleId: module?.id, key: 'internal:' + (module?.id || 'hub'), label: module?.label || 'Internal' };
}
export function requestContext(snapshot, path) {
  if (!snapshot || snapshot.path !== path) return null;
  const { path: ignored, ...context } = snapshot;
  return context;
}
